import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { ENVIRONMENT } from '../tokens/app.tokens';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(ENVIRONMENT);

  if (!req.url.startsWith(env.apiUrl)) {
    return next(req);
  }

  return next(req.clone({ withCredentials: true }));
};
